import * as React from 'react';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';
import CheckmarkCircleIcon from '../../../../../../../Cutesies/CheckmarkCircleIcon';

interface Props {}

const Head: React.FC<Props> = () => (
  <div className="flex flex-col items-center font-semibold text-2xl mt-16">
    <div className="h-[160px] w-[160px] mb-4">
      <CheckmarkCircleIcon className="mx-auto mt-16 fill-green-600" />
    </div>
    <T kind="Participants Added" />
  </div>
);

export default observer(Head);
